"use strict";

define('controller/meeting/list',['require','exports','module','underscore','backbone','moment','langs','controller/base','config','model/board','model/meeting','libs/route.helper','libs/loader.helper','view/calendar.view','view/meeting.summary','view/table.card','uikit/uikit'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var moment = require('moment');
  var langs = require('langs');
  var RegionController = require('controller/base');
  var config = require('config');
  var Board = require('model/board');
  var Meeting = require('model/meeting');
  var RouteHelper = require('libs/route.helper');
  var LoaderHelper = require('libs/loader.helper');
  var CalendarView = require('view/calendar.view');
  var MeetingSummary = require('view/meeting.summary');
  var TableCard = require('view/table.card');
  var UIKit = require('uikit/uikit');
  var p = langs.phrase;
  var DISABLE_MEETING_NAVIGATE = 'DISABLE_MEETING_NAVIGATE';
  var MeetingListController = RegionController.extend({
    initialize: function initialize() {
      RegionController.prototype.initialize.apply(this, arguments);
      this.allMeetings = Meeting.collection();
      this.meetingsByBoard = Meeting.collectionByBoardId(this.state.get('boardId'));
      this.allMeetings.comparator = 'startDate';
      this.meetingsByBoard.comparator = 'startDate';
    },
    header: function header() {
      if (this.app.layout.content === this.region) {
        return p('App.Title');
      }
    },
    authorities: ['PERM_VIEW_MEETING'],
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      app.execute('achievement:unlock', 'Time and Place');
      var root = new CalendarView({
          calendarHeaderText: p('Meetings.Calendar.Title')
        }),
        self = this,
        calendar = root.calendar,
        calendarWeek = root.calendarWeek,
        calendarList = root.calendarList,
        boardDropdown = root.boardDropdown,
        initialBoardId = state.get('boardId'),
        meetingPopup = new UIKit.Popup({
          showOn: 'click',
          size: UIKit.Popup.LARGE
        }),
        boards = Board.all({
          active: true
        }),
        allMeetings = this.allMeetings,
        meetingsByBoard = this.meetingsByBoard,
        listViewMeetings = new Backbone.Collection(),
        meetingLoaderHelper = new LoaderHelper([allMeetings, meetingsByBoard], {
          delay: 0
        }).on('change:loading', function () {
          if (root.isRendered) {
            root.ui.bottomContainer.toggleClass('loading', !!this.get('loading'));
          }
        }).listenTo(root, 'destroy', function () {
          this.off().stopListening();
        }),
        didDoublePressAppointment = false;
      this.root = root;
      root.$el.css(config.contentCss);
      meetingPopup.on('hidden', function () {
        meetingPopup.content.model = null;
      });
      meetingPopup.content = new MeetingSummary().on('more:press', function () {
        if (state.get(DISABLE_MEETING_NAVIGATE)) {
          return;
        }
        var link = new RouteHelper('meeting:detail').add(meetingPopup.content.model, {
          meetingId: 'id'
        }).get('link');
        app.navigate(link.slice(1), {
          trigger: true
        });
      });
      state.trigger('meeting:popup', meetingPopup);
      function gotoToday() {
        var today = moment().startOf('day');
        calendar.year = today.year();
        calendar.month = today.month();
        calendar.value = today;
        root.navigatedToToday = true;
        _.defer(function () {
          root.navigatedToToday = false;
        });
      }
      if (!app.authorities.findWhere({
        authority: 'ROLE_IRB_ANALYST'
      }) && !app.authorities.findWhere({
        authority: 'ROLE_IRB_ADMIN'
      }) || state.get(DISABLE_MEETING_NAVIGATE)) {
        boardDropdown.visible = false;
        if (!state.get(DISABLE_MEETING_NAVIGATE)) {
          initialBoardId = null;
          state.unset('boardId');
        }
      }
      calendar.collection = initialBoardId ? meetingsByBoard : allMeetings;
      calendarWeek.collection = calendar.collection;
      calendarList.collection = listViewMeetings;
      calendarWeek.model = state;
      calendarWeek.bindings.year = 'year';
      calendarWeek.bindings.month = 'month';
      calendarWeek.bindings.date = 'date';
      calendarWeek.childBindings.startTime = 'startDate';
      calendarWeek.childBindings.endTime = 'endDate';
      calendarWeek.childBindings.text = 'board.name';
      calendar.childBindings.eventDate = 'startDate';
      calendar.childBindings.text = 'board.name';
      calendar.bindings.year = 'year';
      calendar.bindings.month = 'month';
      calendar.bindings.selectedDate = 'date';
      calendar.model = state;
      boardDropdown.collection = new Backbone.Collection();
      boardDropdown.childBindings.text = 'name';
      root.addMeeting.visible = app.user.person.hasPermission('CREATE_MEETING');
      root.addMeeting.on('press', function () {
        var linkModel = new RouteHelper('meeting:create');
        if (calendar.value) {
          linkModel.add(new Backbone.Model({
            date: +calendar.value
          }));
        }
        if (state.get('boardId')) {
          linkModel.add(new Backbone.Model({
            boardId: state.get('boardId')
          }));
        }
        app.navigate(linkModel.get('link').slice(1), {
          trigger: true
        });
      });
      root.on('todayButton:press', gotoToday).on('previousButton:press', function () {
        switch (state.get('tab')) {
          case 'week':
            calendarWeek.subtractFromDate(7, 'days');
            break;
          default:
            calendar.month--;
            break;
        }
      }).on('nextButton:press', function () {
        switch (state.get('tab')) {
          case 'week':
            calendarWeek.addToDate(7, 'days');
            break;
          default:
            calendar.month++;
            break;
        }
      });
      var popupTimeout = null;
      function appointmentDoublePress(view, model) {
        if (state.get(DISABLE_MEETING_NAVIGATE) === true) {
          return;
        }
        var link = new RouteHelper('meeting:detail').add(model, {
          meetingId: 'id'
        }).get('link');
        didDoublePressAppointment = true;
        app.navigate(link.slice(1), {
          trigger: true
        });
        clearTimeout(popupTimeout);
      }
      function positionPopup(appointment, calendar) {
        var el = appointment.$el,
          position = el.position(),
          height = el.height(),
          leftOffset = el.offset().left,
          rightPosition = $('.minor.interval').width() - leftOffset,
          intervalWidth = $('.time.interval').width(),
          scroller = calendarWeek.$el.find('.scroller'),
          scrollTop = scroller.scrollTop(),
          windowHeight = scroller.height(),
          scrollOffset = position.top - scrollTop,
          newPosition = 'top left';
        if (calendar == calendarWeek) {
          if (scrollOffset < 150 && (height < 150 || -scrollOffset > height / 2 - 50)) {
            newPosition = 'bottom right';
          } else if (rightPosition < intervalWidth) {
            newPosition = 'left center';
          } else if (height > windowHeight && leftOffset > 2 * intervalWidth) {
            newPosition = 'left center';
          } else if (leftOffset < 2 * intervalWidth) {
            newPosition = 'right center';
          } else if (scrollOffset < 150) {
            newPosition = 'left center';
          }
        }
        meetingPopup.options.position = newPosition;
      }
      function appointmentPress(view, model) {
        var self = this;
        if (meetingPopup.content && meetingPopup.content.model === model) {
          return;
        }
        clearTimeout(popupTimeout);
        popupTimeout = setTimeout(function () {
          positionPopup(view, self);
          meetingPopup.content.model = model;
          meetingPopup.content.render();
          meetingPopup.showNow(view);
        }, 50);
      }
      calendar.on('change:start change:end', _.debounce(function () {
        var start = +calendar.start,
          end = +moment([calendar.year, calendar.month, 1]).add(root.listRangeLength, 'months').endOf('month');
        allMeetings.params({
          start: start,
          end: end
        });
        meetingsByBoard.params({
          start: start,
          end: end
        });
        calendar.collection.fetch();
      })).on('more:press', function (view, model) {
        var m = moment(model.get('eventDate'));
        calendar.value = m;
        calendarWeek.date = +m;
        state.set('tab', 'week');
      }).on('day:double:press', function (view, model) {
        if (app.user.person.hasPermission('CREATE_MEETING') && !didDoublePressAppointment) {
          var link = new RouteHelper('meeting:create').add({
            date: +view.moment
          }).get('link');
          app.navigate(link.slice(1), {
            trigger: true
          });
        }
      }).on('appointment:double:press', appointmentDoublePress).on('appointment:press', appointmentPress);
      calendarWeek.on('appointment:double:press', appointmentDoublePress).on('appointment:press', appointmentPress).on('change:date', function () {
        if (!calendar.isDayVisible(calendarWeek.date)) {
          var m = moment(calendarWeek.date);
          calendar.year = m.year();
          calendar.month = m.month();
        }
      });
      state.trigger('init:calendar', calendar);
      state.trigger('init:calendarWeek', calendarWeek);
      state.trigger('init:addMeeting', root.addMeeting);
      root.on('calendarMenu:childview:press', function (menu, item) {
        var tab = item.getOption('name');
        state.set('tab', tab);
        if (tab == 'week') {
          _.defer(function () {
            calendarWeek.calculateContentHeight();
          });
        }
      }).on('calendarList:before:add:child', function (cardList, card) {
        if (card instanceof TableCard) {
          card.table.rowLinkFormatter = RouteHelper.linkFormatGenerator('meeting:detail', {
            meetingId: 'id'
          });
        }
      }).listenTo(boardDropdown, 'change:value', function () {
        if (!boardDropdown.value) {
          boardDropdown.value = boardDropdown.collection.first();
          return;
        }
        if (boardDropdown.value === boardDropdown.collection.first()) {
          boardDropdown.clearable = false;
          calendar.collection = allMeetings;
          state.unset('boardId');
        } else {
          state.set('boardId', boardDropdown.value.id);
          calendar.collection = meetingsByBoard.params({
            boardId: boardDropdown.value.id
          });
          meetingsByBoard.reset();
          boardDropdown.clearable = true;
        }
        calendarWeek.collection = calendar.collection;
        if (calendar.collection._params.has('start')) {
          calendar.collection.fetch();
        }
      });
      function syncMeetingsToListCollection() {
        var collection = state.has('boardId') ? meetingsByBoard : allMeetings,
          startOfMonth = moment([calendar.year, calendar.month, 1]).startOf('month'),
          endOfMonth = moment([calendar.year, calendar.month, 1]).endOf('month');
        var list = collection.filter(function (model) {
          return moment(model.get(calendar.childBindings.eventDate)).isAfter(startOfMonth);
        });
        listViewMeetings.set(self.processMeetingsForList(new Backbone.Collection(list)));
      }
      ;
      root.listenTo(allMeetings, 'sync', syncMeetingsToListCollection).listenTo(meetingsByBoard, 'sync', syncMeetingsToListCollection).listenTo(boards, 'sync', function () {
        boardDropdown.collection.set(boards.models);
        boardDropdown.collection.unshift(new Backbone.Model({
          name: 'All Boards'
        }));
        boardDropdown.value = initialBoardId ? boards.get(initialBoardId) : boardDropdown.collection.first();
      });
      function updateActiveButton() {
        var tab = state.get('tab');
        meetingPopup.content.model = null;
        root.calendarMenu.each(function (view) {
          if (view.getOption('name') == tab) {
            view.active = true;
          } else {
            view.active = false;
          }
        });
        if (tab == 'week') {
          root.calendarContainer.visible = false;
          root.calendarWeekContainer.visible = true;
          root.calendarListContainer.visible = false;
          root.calendarWeek.triggerMethod('show');
        } else if (tab == 'list') {
          root.calendarContainer.visible = false;
          root.calendarWeekContainer.visible = false;
          root.calendarListContainer.visible = true;
        } else {
          root.calendarContainer.visible = true;
          root.calendarWeekContainer.visible = false;
          root.calendarListContainer.visible = false;
          root.calendar.triggerMethod('show');
        }
      }
      state.set({
        tab: state.get('tab') || 'month',
        month: _.isNaN(Number(state.get('month'))) ? new Date().getMonth() : Number(state.get('month')),
        year: _.isNaN(Number(state.get('year'))) ? new Date().getFullYear() : Number(state.get('year'))
      });
      calendar.year = state.get('year');
      calendar.month = state.get('month');
      if (state.has('date') && !_.isNaN(Number(state.get('date')))) {
        state.set('date', Number(state.get('date')));
      } else {
        state.set('date', new Date().getTime());
      }
      if (boardDropdown.visible) {
        boards.fetch();
      }
      state.addPageDependencies([]);
      root.listenTo(state, 'change:tab', updateActiveButton);
      region.show(root);
      updateActiveButton();
      function selectAvailableDay() {
        if (root.navigatedToToday) {
          return;
        }
        _.defer(function () {
          calendar.value = moment({
            year: calendar.year,
            month: calendar.month,
            day: 1
          });
        });
      }
      calendar.on('change:year change:month', _.debounce(selectAvailableDay));
    },
    getMeetingCollection: function getMeetingCollection() {
      return this.state.has('boardId') ? this.meetingsByBoard : this.allMeetings;
    },
    processMeetingsForList: function processMeetingsForList(list) {
      var previousTime = null,
        currentCollection,
        dayList = [];
      list.each(function (model) {
        var startTime = moment(model.get(this.root.calendar.childBindings.eventDate));
        if (!startTime.isSame(previousTime, 'month')) {
          previousTime = +startTime;
          currentCollection = new Backbone.Collection();
          dayList.push(new Backbone.Model({
            header: startTime.format('MMMM YYYY'),
            collection: currentCollection
          }));
        }
        currentCollection.push(model);
      }, this);
      if (dayList.length === 0) {
        dayList.push(new CalendarView.EmptyModel({
          icon: 'frown',
          text: 'No Meetings'
        }));
      }
      return dayList;
    }
  });
  module.exports = MeetingListController;
});

